/*
 * @Descripttion: 组件初始化时候假数据
 * @Author: zenghua.wang
 * @Date: 2021-06-18 10:13:07
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-12 10:33:42
 */
export default {
  // 获取是否分页url
  getUrl: function(page) {
    let url = '/apis/' + (page ? 'queryPage' : 'query') + '/'
    return url
  },
  // 列表
  report: {
    column: [
      {
        width: 'auto',
        align: 'center',
        color: '#333',
        prop: 'id',
        label: '编号',
        type: 'text',
        fixed: false,
        sortable: false,
        filterable: false,
        filters: [],
        dicFrom: '静态',
        isColspan: false,
        search: false,
        searchKey: null,
        showType: 'show',
        isLink: false,
        url: '',
        urlType: 'outer',
        urlPath: '',
        urlParams: [],
        contentAlign: 'center',
        contentColor: '',
        dicUrl: '',
        dicMethod: ''
      },
      {
        width: 'auto',
        align: 'center',
        color: '#333',
        prop: 'name',
        label: '姓名',
        type: 'text',
        fixed: false,
        sortable: false,
        filterable: false,
        filters: [],
        dicFrom: '静态',
        isColspan: false,
        search: false,
        searchKey: null,
        showType: 'show',
        isLink: false,
        url: '',
        urlType: 'outer',
        urlPath: '',
        urlParams: [],
        contentAlign: 'center',
        contentColor: '',
        dicUrl: '',
        dicMethod: ''
      },
      {
        width: 'auto',
        align: 'center',
        color: '#333',
        prop: 'sex',
        label: '性别',
        type: 'text',
        fixed: false,
        sortable: false,
        filterable: false,
        filters: [],
        dicFrom: '静态',
        isColspan: false,
        search: false,
        searchKey: null,
        showType: 'show',
        isLink: false,
        url: '',
        urlType: 'outer',
        urlPath: '',
        urlParams: [],
        contentAlign: 'center',
        contentColor: '',
        dicUrl: '',
        dicMethod: ''
      }
    ],
    data: [
      {
        id: 2021001,
        name: '张三',
        sex: '男'
      },
      {
        id: 2021002,
        name: '李四',
        sex: '男'
      }
    ]
  },
  // 轮播表
  scrollboad: {
    column: [
      {
        label: '班级',
        prop: 'className',
        type: 'text',
        width: 'auto',
        align: 'center',
        color: ''
      },
      {
        label: '班主任',
        prop: 'name',
        type: 'text',
        width: 'auto',
        align: 'center',
        color: ''
      },
      {
        label: '性别',
        prop: 'sex',
        type: 'select',
        width: 'auto',
        align: 'center',
        color: '',
        dicFrom: '静态',
        dicData: [
          {
            id: '1635148830138',
            label: '男',
            value: '1',
            disabled: false
          },
          {
            id: '1635148818749',
            label: '女',
            value: '2',
            disabled: false
          }
        ],
        dicUrl: '',
        dicMethod: ''
      },
      {
        label: '班级人数',
        prop: 'classCount',
        type: 'number',
        width: 'auto',
        align: 'center',
        color: '',
        dicFrom: '静态',
        dicData: [],
        dicUrl: '',
        dicMethod: ''
      },
      {
        label: '平均分',
        prop: 'sum',
        type: 'number',
        width: 'auto',
        align: 'center',
        color: '',
        dicFrom: '静态',
        dicData: [],
        dicUrl: '',
        dicMethod: ''
      }
    ],
    rowsData: [
      {
        className: '一班',
        classCount: '40',
        id: '1',
        name: '张老师',
        sex: '1',
        sum: '500'
      },
      {
        className: '二班',
        classCount: '41',
        id: '2',
        name: '李老师',
        sex: '2',
        sum: '600'
      },
      {
        className: '三班',
        classCount: '43',
        id: '3',
        name: '王老师',
        sex: '1',
        sum: '550'
      },
      {
        className: '四班',
        classCount: '45',
        id: '4',
        name: '赵老师',
        sex: '2',
        sum: '560'
      },
      {
        className: '五班',
        classCount: '46',
        id: '1',
        name: '秦老师',
        sex: '1',
        sum: '500'
      }
    ]
  },
  // 统计图表
  echart: {
    categories: ['苹果', '华为', '小米', 'oppo', 'vivo'],
    series: [
      {
        name: '手机品牌',
        data: [
          { value: 10853, name: '苹果' },
          { value: 54898, name: '华为' },
          { value: 23837, name: '小米' },
          { value: 34456, name: 'oppo' },
          { value: 23568, name: 'vivo' }
        ]
      }
    ],
    radar: {
      indicator: [
        {
          name: '语文',
          max: 150
        },
        {
          name: '数学',
          max: 150
        },
        {
          name: '英语',
          max: 150
        },
        {
          name: '物理',
          max: 100
        },
        {
          name: '化学',
          max: 100
        },
        {
          name: '生物',
          max: 100
        }
      ],
      data: [
        {
          value: [124, 98, 106, 86, 78, 75],
          name: '平均成绩'
        }
      ]
    },
    gauge: [
      {
        value: 80,
        name: '成绩等级'
      }
    ],
    map: [
      {
        name: '云南省',
        center: [102.712251, 25.040609],
        value: 24485
      },
      {
        name: '山东省',
        center: [117.000923, 36.675807],
        value: 13480
      },
      {
        name: '湖北省',
        center: [114.298572, 30.584355],
        value: 12873
      },
      {
        name: '黑龙江省',
        center: [126.642464, 45.756967],
        value: 10487
      },
      {
        name: '四川省',
        center: [104.065735, 30.659462],
        value: 14980
      }
    ]
  },
  // 卡片
  card: {
    column: [
      {
        prop: 'school',
        name: '学校',
        value: '1000',
        titleFontSize: 14,
        titleFontWeight: 'normal',
        titleColor: '#666',
        textFontSize: 20,
        textFontWeight: 'bold',
        textColor: '#3B9CD9',
        suffixText: '所'
      },
      {
        prop: 'teacher',
        name: '教师人数',
        value: '23875',
        titleFontSize: 14,
        titleFontWeight: 'normal',
        titleColor: '#666',
        textFontSize: 20,
        textFontWeight: 'bold',
        textColor: '#3B9CD9',
        suffixText: '人'
      },
      {
        prop: 'student',
        name: '在校学生人数',
        value: '894767',
        titleFontSize: 14,
        titleFontWeight: 'normal',
        titleColor: '#666',
        textFontSize: 20,
        textFontWeight: 'bold',
        textColor: '#3B9CD9',
        suffixText: '人'
      }
    ],
    list: [
      {
        name: '学校领导',
        value: '1000'
      },
      {
        name: '教师人数',
        value: '23875'
      },
      {
        name: '在校学生人数',
        value: '894767'
      }
    ]
  },
  swiper: {
    list: [
      {
        name: '图片一',
        value: 'https://img01.yzcdn.cn/vant/apple-1.jpg'
      },
      {
        name: '图片二',
        value: 'https://img01.yzcdn.cn/vant/apple-2.jpg'
      }
    ]
  },
  // 选项卡
  tabs: [
    {
      name: '选项一',
      value: '1'
    },
    {
      name: '选项二',
      value: '2'
    }
  ]
}
